/* eslint-disable @typescript-eslint/default-param-last */
import { combineReducers } from 'redux';

import * as c from './types';

export const initState = {};

initState.user = {};
const user = (state = initState.user, { type, payload }) => {
  switch (type) {
    case c.LOGIN.SUCCESS:
    case c.INIT_SESSION.SUCCESS:
      return payload;
    case c.LOGOUT:
      return initState.user;
    default:
      return state;
  }
};

initState.loading = 0;
const loading = (state = initState.loading, { type }) => {
  switch (type) {
    case c.LOGIN.START:
    case c.INIT_SESSION.START:
    case c.LOGOUT.START:
      return state + 1;
    case c.LOGIN.SUCCESS:
    case c.LOGIN.ERROR:
    case c.INIT_SESSION.SUCCESS:
    case c.INIT_SESSION.ERROR:
    case c.LOGOUT.SUCCESS:
    case c.LOGOUT.ERROR:
      return state - 1;
    default:
      return state;
  }
};

export default combineReducers({ user, loading });
